<template>
    <transition name="slide-fade">
        <div v-if="showLoading"
            style="position:absolute;width:100%;height:100%;top:0;left:0;background-color:rgb(0 0 0 / 50%);display: flex;flex-direction: column;align-items:center;justify-content: center;z-index:100">
            <div class="loading" style="width:100px;height:100px;background-color:#fff;border-radius: 50% / 50%;"></div>
        </div>
    </transition>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    showLoading: Boolean
  }
}
</script>
<style lang="scss">
    .loading{
        animation: loading-anim 500ms infinite alternate;
        animation-timing-function: cubic-bezier(0.51, -0.05, 0.76, 0.25);
    }
    @keyframes loading-anim {
    0% {
        width: 100px;
        height: 100px;
        margin-top: 0px;
    }
    90% {
        width: 103px;
        height: 100px;
        margin-top: 90px;
    }
    100% {
        width: 110px;
        height: 95px;
        margin-top: 100px;
    }
    }

    .slide-fade-enter-active {
        transition: all 200ms ease;
    }
    .slide-fade-leave-active {
        transition: all 200ms ease;
    }
    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
    }
</style>